import { HierarchyUtils, TransformUtils, Vector, } from "@inter-ikea-core/core";
import { createViewerObjectEntity } from "../utils/viewerObjectHandler";
import { getEntitySize } from "../utils/getEntityData";
import { getTemplateDataComponent } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { CHILD_MISSING_PARENT } from "@inter-ikea-storagetwo/range/dist/constants/errors";
const VALID_INSERTS = [
    "section-boaxel-drying-rack",
    "section-boaxel-wire-shelf",
];
/**
 * Checks if an insert is of the correct type by checking the assembly roots template id.
 *
 * @param insert The insert entity to validate.
 * @returns True if exists in [VALID_INSERTS], otherwise false
 */
export const isValidInsert = (insert) => {
    const parent = HierarchyUtils.parent(insert);
    if (!parent)
        throw new Error(CHILD_MISSING_PARENT);
    const templateId = getTemplateDataComponent(parent).templateId;
    return VALID_INSERTS.includes(templateId);
};
/**
 * Creates a viewer object & viewer object entity that gets an insert entity parented to it.
 *
 * @param insert - Entity that will be parented to the viewer object entity
 * @param core - Core
 */
export const attachViewerObjectToInsert = (insert, core) => {
    const { viewerObjectEntity } = createViewerObjectEntity(core, insert, getEntitySize(insert));
    // This is an offset due to the bound of the insert (NOT the assembly) being "incorrect".
    // The issue is the models dimensions not being correct.
    TransformUtils.moveInParentSpace(viewerObjectEntity, new Vector(0, 10, -20));
};
